import { imageString } from '../../helper';

export const IMAGE_ENTITY_TYPE = {
  AMENITY: 1,
  EVENT: 2
};

const mapImagePreviewUrl = (url) => {
  if (url == null || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  return trimmed.startsWith('http') ? trimmed : imageString(trimmed);
};

export const mapEntityImages = (images) => {
  if (!Array.isArray(images) || images.length === 0) return [];

  return [...images]
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
    .map((img) => ({
      id: img.id != null ? String(img.id) : Math.random().toString(),
      preview: mapImagePreviewUrl(img.url),
      file: null,
      isExisting: true
    }))
    .filter((img) => img.preview);
};

export const createNextUploadKey = (counterRef) => {
  const key = `new-${counterRef.current}`;
  counterRef.current += 1;
  return key;
};

export const createNewImageItem = (file, uploadKey) => ({
  id: Math.random().toString(),
  ...(uploadKey ? { uploadKey } : {}),
  file,
  preview: URL.createObjectURL(file)
});

export const buildImageManifest = (images) => {
  const manifestImages = (images ?? [])
    .map((img, index) => {
      const sort_order = index + 1;

      if (img?.isExisting && img.id != null) {
        const id = Number(img.id);
        if (Number.isNaN(id)) return null;
        return { id, sort_order };
      }

      if (img?.file instanceof File && img.uploadKey) {
        return { upload_key: img.uploadKey, sort_order };
      }

      return null;
    })
    .filter(Boolean);

  return { images: manifestImages };
};

export const manifestsEqual = (a, b) =>
  JSON.stringify(a ?? { images: [] }) === JSON.stringify(b ?? { images: [] });

export const buildImagesBatchFormData = ({
  images,
  entityId,
  entityType,
  orgId,
  buildingId
}) => {
  const formData = new FormData();
  formData.append('org', orgId);
  formData.append('building', buildingId);
  formData.append('entity_type', entityType);
  formData.append('entity_id', entityId);

  (images || []).forEach((imgObj) => {
    if (imgObj?.file instanceof File) {
      formData.append('images', imgObj.file);
    }
  });

  return formData;
};

export const buildImageSyncFormData = ({
  images,
  entityId,
  entityType,
  orgId,
  buildingId
}) => {
  const manifest = buildImageManifest(images);
  const formData = new FormData();

  formData.append('entity_type', String(entityType));
  formData.append('entity_id', String(entityId));
  formData.append('org', String(orgId));
  formData.append('building', String(buildingId));
  formData.append('manifest', JSON.stringify(manifest));

  manifest.images.forEach((entry) => {
    if (!entry.upload_key) return;
    const img = images.find((i) => i.uploadKey === entry.upload_key);
    if (img?.file instanceof File) {
      formData.append(entry.upload_key, img.file);
    }
  });

  return formData;
};

export const revokeImageBlobUrls = (images) => {
  (images || []).forEach((img) => {
    if (img?.preview?.startsWith('blob:')) {
      URL.revokeObjectURL(img.preview);
    }
  });
};
